import type { DensityParams } from "./types";

export type SpawnCategory = keyof Pick<
    DensityParams,
    "treeDensity" | "rockDensity" | "dogDensity" | "hikerDensity" | "npcRiderDensity" | "wildlifeDensity" | "jumpFrequency" | "regionFrequency"
>;

export const SPAWN_CATEGORY: Record<string, SpawnCategory> = {
    pine_small: "treeDensity",
    pine_large: "treeDensity",
    tree_leafy: "treeDensity",
    stump: "treeDensity",
    log: "treeDensity",
    fern: "treeDensity",

    rock_small: "rockDensity",
    rock_large: "rockDensity",
    outcrop: "rockDensity",
    bush: "rockDensity",
    fence: "rockDensity",
    hay_bale: "rockDensity",
    warning_sign: "rockDensity",

    dog: "dogDensity",
    hiker: "hikerDensity",
    npc_rider: "npcRiderDensity",
    wildlife: "wildlifeDensity",

    roller: "jumpFrequency",
    kicker: "jumpFrequency",
    tabletop: "jumpFrequency",

    mud: "regionFrequency",
    puddle: "regionFrequency",
    gravel: "regionFrequency",
    roots: "regionFrequency",
};

export const SPAWN_CATEGORIES = [...new Set(Object.values(SPAWN_CATEGORY))];
